import { isSupabaseConfigured, SUPABASE_ANON_KEY, SUPABASE_URL } from "../config/supabasePublic";

function catalogUrl() {
  return `${String(SUPABASE_URL).replace(/\/$/, "")}/rest/v1/rpc/get_public_plan_catalog`;
}

function anonHeaders() {
  return {
    "Content-Type": "application/json",
    apikey: SUPABASE_ANON_KEY,
    Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
  };
}

function toNumberOrNull(v) {
  if (v == null || v === "") return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

/**
 * @returns {Promise<{
 *   ok: boolean,
 *   byCode?: Record<string, { listPriceFc: number | null, promoPriceFc: number | null, promoActive: boolean }>,
 *   error?: string,
 * }>}
 */
export async function fetchPublicPlanCatalog() {
  if (!isSupabaseConfigured()) {
    return { ok: false, error: "Configuration serveur manquante." };
  }
  try {
    const res = await fetch(catalogUrl(), {
      method: "POST",
      headers: anonHeaders(),
      body: "{}",
    });
    const body = await res.json().catch(() => null);
    if (!res.ok) {
      return {
        ok: false,
        error:
          (body && typeof body.message === "string" && body.message) ||
          (body && typeof body.error === "string" && body.error) ||
          `Erreur ${res.status}`,
      };
    }
    const rows = Array.isArray(body) ? body : [];
    /** @type {Record<string, { listPriceFc: number | null, promoPriceFc: number | null, promoActive: boolean }>} */
    const byCode = {};
    for (const row of rows) {
      const code = String(row?.code ?? "").trim().toLowerCase();
      if (!code) continue;
      byCode[code] = {
        listPriceFc: toNumberOrNull(row.listPriceFc ?? row.list_price_fc),
        promoPriceFc: toNumberOrNull(row.promoPriceFc ?? row.promo_price_fc),
        promoActive: Boolean(row.promoActive ?? row.promo_active),
      };
    }
    return { ok: true, byCode };
  } catch (e) {
    return { ok: false, error: String(e?.message ?? e) };
  }
}
